<span class="d-flex d-inline-flex">
  <span [class.text-grey-dark]="isNew">
    @if (!disabled) {
      <ng-container>
        @if (!eInvoiceSrv.isEnabled) {
          <input
            nz-input
            [ngModel]="manualCode"
            (ngModelChange)="onModelChange($event)"
            class="code"
            placeholder="{{ placeHolder }}"
            (click)="onClick($event.target)"
            [readonly]="readonly"
          />
        } 
        @else {
          <input
            nz-input
            [ngModel]="manualCode"
            (ngModelChange)="onModelChange($event)"
            class="code"
            placeholder="{{ placeHolder }}"
            (click)="onClick($event.target)"
            (keydown)="onKeydown($event)"
            [readonly]="readonly"
          />
        }
      </ng-container>
    }
    @else {
      <ng-container>
        <span class="code">{{ manualCode }}</span>
      </ng-container>
    }
  </span>

  @if (isNew) {
    <ng-container>
      <button type="button"
        nz-button
        nzType="text"
        nz-dropdown
        nzTrigger="hover"
        [nzDropdownMenu]="menu"
        nzPlacement="bottomRight"
        nzSize="large"
      >
        <span nz-icon nzType="down" class="display-2"></span>
      </button>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu nzSelectable>
          <li
            nz-menu-item
            *ngFor="let item of autoCodeSrv.formats"
            (click)="selectFormat(item)"
          >
            <strong>
              {{ item.format }}
            </strong>
            <nz-divider nzType="vertical"></nz-divider>
            <span class="text-grey-dark">
              {{ item.sampleCode }}
            </span>
          </li>
        </ul>
      </nz-dropdown-menu>
    </ng-container>
  }
</span>
